import { render } from "./NotFound.view.vue?vue&type=template&id=9217c308"
const script = {}

import exportComponent from "/var/lib/jenkins/workspace/MONICAS/FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__